module.exports = __webpack_public_path__ + "files/df487c6826bb4cd647abfa145972faa1.png";